<template>
  <q-page>
    <router-view v-if="!loading" />
  </q-page>
</template>

<script>
import module from '../index'

export default {
  name: 'Entry',
  data: () => ({
    loading: true
  }),
  async beforeCreate () {
    await this.$registerModule(module)
    this.loading = false
  }
}
</script>
